import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";
import * as moment from "moment";
import { EntityConfigService } from "../services/entity-config-service";
import { AccountService } from "../services/account-service";
import { LocalCacheService } from "../services/local-cache-service";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { SearchService } from "../services/search-service";
import { CustomViewsService } from "../services/custom-views-service";


export function RLAssociationTableHierarchy(): ng.IDirective {
    return {
        restrict: 'E',
        bindToController: true,
        controller: RLAssociationTableHierarchyController,
        controllerAs: 'athVM',
        scope: {
            charTypeID: '=charTypeId',
            entityDocuments: '=',
            visibility: '=',
            locked: '=',
            canEdit: '=',
            isParentChar: "=",
            entityID: "=entityId",
            refreshPanel: "=",
            parentOpen: "=",
            initialized: '=?',
            customColumns: '=?',
            templateMetaData: '=?',
            sortDir: '=?',
            sortField: '=?',
            page: '=?',
            pageCount: '=?',
            rowCount: '=?',
            numFound: '=?',
            selectable: '=?',
            selectedItems: '=?',
            selectedItemsArray: '=?',
            charTypeName: '=?'
        },
        template: require("/assets/app/templates/association-table-hierarchy.html")
    }
}

class RLAssociationTableHierarchyController {
    static $inject = ['$scope', '$q', "$rootScope", "$filter", "$location", "$window", 'entityConfigService', 'accountService', 'localCacheService', "entityService", "notifyService", "eventService", "searchService", 'customViewsService'];

    charTypeID: number;
    selectable: boolean;
    allChecked: boolean;
    page: number;
    pageCount: number;
    rowCount: number;
    numFound: number;

    // not really a fan of this but sticking with the way it was already done in contact and catalog search controllers
    selectedItems: { [recIDTitle: string]: boolean } = {};
    selectedItemsArray: Models.IEntitySearchDoc[] = [];

    initialized: boolean;
    visibility: number;

    availableColumns: Models.IListTableColumn[];

    customColumns: Models.ICustomUserColumns;

    selectedListID: string;
    charTypeUrl: string;

    entityDocuments: Models.IEntitySearchDoc[];
    rows: Models.IListTableRow[];
    entityRoot: Models.IEntitySearchDoc;
    entityHierarchy: Models.IEntityHierarchy;

    locked: boolean;
    canEdit: boolean;
    isParentChar: boolean;
    entityID: string;
    refreshPanel: boolean;
    recID: number;
    parentOpen: boolean;

    loading: boolean;
    totalDescendants: number;
    charTypeName: string;
    previewEntityID: string;

    constructor(
        $scope: ng.IScope,
        private $q: ng.IQService,
        private $rootScope: ng.IRootScopeService,
        private $filter: ng.IFilterService,
        private $location: ng.ILocationService,
        private $window: ng.IWindowService,
        private entityConfigService: EntityConfigService,
        private accountService: AccountService,
        private cacheService: LocalCacheService,
        private entityService: EntityService,
        private notifyService: NotifyService,
        private eventService: EventService,
        private searchService: SearchService,
        private customViewsService: CustomViewsService) {

        this.loading = true;
        this.totalDescendants = 0;
        this.previewEntityID = "";

        $scope.$watch(() => this.charTypeID, (newValue, oldValue) => {
            if (newValue) {
                this.charTypeUrl = Utils.UrlBuilder.getCharTypeSummaryUrl(this.charTypeID);
                this.getCharacteristicList(this.charTypeID);
            }
        });

        $scope.$watchCollection(() => [this.entityDocuments, this.customColumns, this.availableColumns], (newValue, oldValue) => {
            if (this.customColumns && this.entityDocuments && this.availableColumns) {
                this.setupRows(this.entityDocuments, this.customColumns.columns);
                this.entityHierarchy = null;
                if (this.entityDocuments.length > 0) {
                    let entityId = _.first(this.entityDocuments).entityID;
                    this.GetBaseHierarchy(entityId);
                }
            }
        });

        $scope.$watch(() => this.entityID, (newValue, oldValue) => {
            this.recID = Utils.IdBuilder.splitEntityID(newValue).recID;
        })

        $scope.$watch(() => this.entityHierarchy, (newValue, oldValue) => {
            if (newValue && this.entityDocuments.length > 0) {
                this.loading = false;
            }
            else {
                this.loading = true;
            }
        });
    }

    GetBaseHierarchy(entityID: string) {
        var charTypeID = Utils.IdBuilder.splitEntityID(entityID).charTypeID;
        this.searchService.getEntityHierarchy(entityID, charTypeID, 1)
            .then((results) => {
                if (results.success) {
                    this.entityHierarchy = results.data;
                    this.entityRoot = _.first(this.entityDocuments);
                }
            });

        this.searchService.getChildHierarchyCount(entityID)
            .then((result) => {
                this.totalDescendants = result.data;
            });
    }
    private setupRows(itemRows: Models.IEntitySearchDoc[], customColumns: Models.ICustomUserColumn[]) {
        var customColumns: Models.ICustomUserColumn[] = this.customColumns.columns;
        var specialColumns = this.customViewsService.GetSpecialColumns(this.charTypeID);

        customColumns.forEach((col) => {
            if (col.solrLabel.indexOf('_date') > -1 || col.solrLabel.indexOf('_updated') > -1 || col.solrLabel == 'created') {
                col.formatter = 'dateLocal:"L"';
            }

            // nearly duplicate of code from column-picker.ts, refactor
            if (col.solrLabel.indexOf('_') > -1) {
                var split = col.solrLabel.split('_');
                col.label = '';
                split.forEach((val) => {
                    col.label += val.substr(0, 1).toUpperCase() + val.substr(1, val.length - 1) + ' ';
                });
            } else if (col.solrLabel == 'userlabel') {
                col.label = 'Contact';
            } else if (col.solrLabel == 'companylabel') {
                col.label = 'Company';
            } else if (col.solrLabel == 'created') {
                col.label = 'Created';
            }

            if (col.solrLabel == 'transaction_id') {
                col.label = 'Deal ID';
            }
        });

        this.rows = [];
        itemRows.forEach((row) => {
            var sortedColumns = _.sortBy(customColumns, (col) => { return col.sequenceNumber; });

            var columns: Models.IListTableColumn[] = [];
            sortedColumns.forEach((col) => {
                if (col.characteristicID) {
                    var characteristic = _.find(this.availableColumns, (aCol) => {
                        return aCol.characteristicID === col.characteristicID;
                    });

                    // actual characteristic
                    if (row.characteristics[characteristic.solrLabel]) {
                        columns.push({
                            characteristicID: col.characteristicID,
                            solrLabel: characteristic.solrLabel,
                            label: characteristic.label || characteristic.solrLabel,
                            value: _.isArray(row.characteristics[characteristic.solrLabel]) ? row.characteristics[characteristic.solrLabel][0] : row.characteristics[characteristic.solrLabel],
                            formatter: characteristic.formatter,
                            dataTypeID: characteristic.dataTypeID,
                            systemIndicatorID: characteristic.systemIndicatorID
                        });
                    }
                    // header-level
                    else if (row[characteristic.solrLabel]) {
                        columns.push({
                            characteristicID: col.characteristicID,
                            solrLabel: characteristic.solrLabel,
                            label: characteristic.label,
                            value: row[characteristic.solrLabel],
                            formatter: characteristic.formatter,
                            dataTypeID: characteristic.dataTypeID,
                            systemIndicatorID: characteristic.systemIndicatorID
                        });
                    }
                    else if (characteristic) {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: characteristic.label,
                            value: undefined,
                            dataTypeID: -1,
                            systemIndicatorID: -1
                        });
                    }
                    // missing from this record
                    else {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label,
                            value: undefined,
                            dataTypeID: -1,
                            systemIndicatorID: -1
                        });
                    }
                }
                else if (col.solrLabel) {
                    var characteristic = _.find(this.availableColumns, (aCol) => {
                        return aCol.solrLabel === col.solrLabel;
                    });

                    var specialCol = _.find(specialColumns, (sCol) => {
                        return sCol.solrLabel == col.solrLabel;
                    });
                    var test = this.customViewsService.GetDefaultColumns(this.charTypeID).columns;
                    var defaultCol = _.find(test, (dCol) => {
                        return dCol.solrLabel == col.solrLabel;
                    });

                    if (specialCol) {
                        col.label = specialCol.label;
                    }
                    else if (defaultCol) {
                        col.label = defaultCol.label;
                    }

                    // actual characteristic
                    if (characteristic) {
                        columns.push({
                            characteristicID: col.characteristicID,
                            solrLabel: characteristic.solrLabel,
                            label: characteristic.label,
                            value: row[characteristic.solrLabel] || row.characteristics[characteristic.solrLabel],
                            formatter: characteristic.formatter,
                            dataTypeID: characteristic.dataTypeID,
                            systemIndicatorID: characteristic.systemIndicatorID
                        });
                    }
                    // header value
                    else if (row[col.solrLabel]) {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label,
                            value: row[col.solrLabel],
                            formatter: col.formatter,
                            dataTypeID: -1,
                            systemIndicatorID: -1
                        });
                    }
                    // specially indexed value that is not an actual characteristic
                    else if (row.characteristics[col.solrLabel]) {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label || col.solrLabel,
                            value: row.characteristics[col.solrLabel],
                            formatter: col.formatter,
                            dataTypeID: -1,
                            systemIndicatorID: -1
                        });
                    }
                    // header value with underscore - we need to access value without but sort with
                    else if (col.solrLabel.indexOf('_') > -1) {
                        var split = col.solrLabel.split('_');
                        var label = split[0];
                        split.splice(0, 1);

                        split.forEach((val) => {
                            label += val.substr(0, 1).toUpperCase() + val.substr(1, val.length - 1);
                        });

                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label || col.solrLabel,
                            value: row[label],
                            formatter: col.formatter,
                            dataTypeID: -1,
                            systemIndicatorID: -1
                        });
                    }
                    // dummy value
                    else {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label || col.solrLabel,
                            value: undefined,
                            dataTypeID: -1,
                            systemIndicatorID: -1
                        });
                    }
                }
            });

            this.rows.push({
                recordID: row.recordID,
                columns: columns,
                recordRevisionID: row.recordRevisionID,
                title: row.title,
                currency: row.characteristics['currency_str']
            });
        });

        this.initialized = true;
    }


    private getCharacteristicList(charTypeID: number) {
        return this.entityConfigService.getCharacteristicList(charTypeID)
            .then((res) => {
                var columns = _.sortBy(res, (chr) => {
                    return chr.label;
                }).map((chr): Models.IListTableColumn => {
                    return {
                        solrLabel: Utils.CharUtil.GetCharSolrLabel(chr.dataTypeID, chr.multipleIndicator, chr.tagLabel),
                        label: chr.label,
                        characteristicID: chr.characteristicID,
                        formatter: Utils.CharUtil.GetFormatter(chr.dataTypeID),
                        dataTypeID: chr.dataTypeID,
                        systemIndicatorID: chr.systemIndicator
                    }
                });

                this.availableColumns = columns;
            });
    }

    private setCustomColumnList(charTypeID: number, headerID: string) {
        var key = `CC-${charTypeID}-${headerID}`;
        var colList = this.cacheService.getItem(key);

        if (!colList) {
            this.getCustomListColumns()
                .then(() => {

                });
        }
    }

    private getCustomListColumns() {
        return this.accountService.getCustomColumns()
            .then((res) => {
                var dayExp = moment.duration(1, 'day');
                res.forEach((customColumns) => {
                    this.cacheService.setItem(`CC-${customColumns.charTypeID}-${customColumns.headerID}`, customColumns, dayExp);
                });
            });
    }
}